import { TreeNode, TreeNodeCtrl } from './tree-node';

export class SelectionTreeNode {
  node = new TreeNode<{ selected: boolean; partial: boolean }>({});
  model = { selected: false, partial: false };

  toggleNode(
    treeNodeCtrl: TreeNodeCtrl<{ selected: boolean; partial: boolean }>,
    nodeModel: { selected: boolean; partial: boolean }
  ) {
    const selected = nodeModel.selected;

    treeNodeCtrl.node.traverseChildren((node) => {
      if (node) {
        const indeterminate = this.isNodeCtrlPartiallySelected(node.value);

        if (node.value?.model) {
          node.value.model.selected = selected;
          node.value.model.partial = indeterminate;
        }
      }
    });

    nodeModel.partial = this.isNodeCtrlPartiallySelected(treeNodeCtrl);
    this.updateTree();
  }

  toggleTree() {
    this.node.traverseChildren((node) => {
      if (node.value?.model) {
        node.value.model.selected = this.node.value?.model?.selected ?? false;
      }
    });

    this.updateTree();
  }

  updateTree() {
    this.node.traverseChildren((node) => {
      if (node.value?.model) {
        node.value.model.partial = this.isNodeCtrlPartiallySelected(node.value);
        node.value.model.selected = this.isNodeCtrlSelected(node.value);
      }
    });

    const selected = this.isNodeCtrlSelected(this.node.value);
    const partial = this.isNodeCtrlPartiallySelected(this.node.value);

    if (this.node.value?.model) {
      this.node.value.model.partial = partial;
      this.node.value.model.selected = selected;
    }
  }

  isNodeCtrlPartiallySelected(treeNodeCtrl) {
    const metadata = this.getNodeMetadataFromTreeNodeCtrl(treeNodeCtrl);
    return metadata.selected > 0 && metadata.selected < metadata.total;
  }

  isNodeCtrlSelected(treeNodeCtrl) {
    if (treeNodeCtrl.node.isLeaf()) {
      return treeNodeCtrl.model ? !!treeNodeCtrl.model.selected : false;
    }

    const metadata = this.getNodeMetadataFromTreeNodeCtrl(treeNodeCtrl);

    return metadata.selected > 0;
  }

  getNodeMetadataFromTreeNodeCtrl(nodeCtrl: { node: TreeNode<{ selected: boolean; partial: boolean }> }) {
    let totalNodes = 0;
    let countSelected = 0;

    nodeCtrl.node.traverseChildren((node) => {
      totalNodes += 1;

      if (node.value?.model?.selected) {
        countSelected += 1;
      }
    });

    return {
      total: totalNodes,
      selected: countSelected,
    };
  }
}
